import { FormGenModel } from './../../../../../shared/models/form-gen.model';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'inc-base-modal',
  template: ''
})
export class BaseModalComponent implements OnInit {
  form: FormGroup;
  formGenList: FormGenModel[];
  title: string;

  @Input() parameter: any;

  constructor(protected modalController: ModalController) { }

  ngOnInit() {
    if (this.parameter) {
      this.form.patchValue(this.parameter);
      this.form.updateValueAndValidity();
      this.form.markAsDirty();
    }
  }

  reset(form: FormGroup): void {
    this.form = form;
  }

  close() {
    this.modalController.dismiss();
  }

  baseSave(returnData: any) {
    this.modalController.dismiss(returnData);
  }

}
